/*
  정재윤 at 2018.06.10

  Device Logging
*/
const debug = (msg) => {
  console.log(msg)
  if (window.fdp && window.vue.getStore('root').getters.getApp.state !== '') {
    window.fdp.log.d(msg).then((result) => {
      console.log(result)
    }).catch( (error) => {
      console.log(error)
    })
  }
}

/*
  Parameters
*/
const warn = (msg) => {
  console.warn(msg)
  if (window.fdp && window.vue.getStore('root').getters.getApp.state !== '') {
    window.fdp.log.w(msg).then((result) => {
      console.warn(result)
    }).catch( (error) => {
      console.error(error)
    })
  }
}
/*
  Parameters
*/
const info = (msg) => {
  console.info(msg)
  if (window.fdp && window.vue.getStore('root').getters.getApp.state !== '') {
    window.fdp.log.i(msg).then((result) => {
      console.info(result)
    }).catch( (error) => {
      console.error(error)
    })
  }
}
/*
  Parameters
*/
const error = (msg) => {
  console.error(msg)
  if (window.fdp && window.vue.getStore('root').getters.getApp.state !== '') {
    window.fdp.log.e(msg).then((result) => {
      console.info(result)
    }).catch( (error) => {
      console.error(error)
    })
  }
}

var loggerWrapper = {}

loggerWrapper.debug = debug
loggerWrapper.warn = warn
loggerWrapper.info = info
loggerWrapper.error = error

export default loggerWrapper



// WEBPACK FOOTER //
// ./src/_fdp/core/logger/logger.js